import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const subscriptionsRevenueTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "subscriptions.revenue-trend",
  name: "Subscription revenue trend",
  description: "Subscription revenue trend across the selected period.",
  apps: [
    "subscriptions",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "subscriptions.records",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "recurring_amount",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Recurring revenue",
        query: {
          version: 1,
          source: "subscriptions.records",
          ...period(30),
          select: [
            {
              type: "field",
              field: "start_date",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "recurring_amount",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "start_date",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#2fb344",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "Subscription revenue trend",
    valueFormat: "currency",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "$48,260",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
